// Angular
import {Component} from '@angular/core';
// AG-Grid
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
	selector: 'cv-custom-id-cell',
	templateUrl: './custom-id-cell.component.html',
	styleUrls: ['./custom-id-cell.component.scss']
})
export class CustomIDCellComponent implements ICellRendererAngularComp {
	public cellValue: any;

	/**
	 * When the component renders, it got the possible value
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.cellValue = params.data;
	}

	/**
	 * Put back the value
	 * @param params
	 */
	refresh(params: ICellRendererParams): boolean {
		this.cellValue = params;
		return true;
	}
}
